import { cookieBus } from "@/common/buses";
import { useEffect } from "react";
import { isCookieDeclined } from "@/common/utils/cookie";

export const useGTM = () => {
  const init = async () => {
    if (await isCookieDeclined(["analytics"])) {
      return;
    }

    if (document.querySelector("#gtm-script") !== null) {
      return;
    }

    const script = document.createElement("script");
    script.id = "gtm-script";
    script.type = "text/partytown";
    script.src = `https://www.googletagmanager.com/gtm.js?id=${import.meta.env.REACT_APP_GTM_ID}`;
    document.head.appendChild(script);

    window.dispatchEvent(new CustomEvent("ptupdate"));
  };

  useEffect(() => {
    cookieBus.on("consent_update", init);

    init();

    return () => {
      cookieBus.off("consent_update", init);
    };
  }, []);
};
